import { jsx as _jsx } from "react/jsx-runtime";
export const CaretDown = () => (_jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 512 512', children: _jsx("path", { d: 'M339.9 213.3c9 0 14 10.5 8.2 17.5L264.2 331.5c-4.3 5.1-12.1 5.1-16.4 0L163.9 230.8c-5.8-6.9-.8-17.5 8.2-17.5H339.9z' }) }));
